function upsellRecommended() {
  const cartDrawer = document.querySelector('.cart-drawer');
  const productRecommendationsSections = cartDrawer.querySelectorAll('.product-recommendations');

  const itemCount = productRecommendationsSections.length;
  

  // Variable to accumulate the recommendations
  let allRecommendationsHTML = '';

  const loadRecommendations = (section, index) => {
    if (!section) {
      console.error("Product recommendations section not found.");
      return;
    }
    const url = section.dataset.url;
    // console.log("data-URL",dataURL);
    // const url = section.dataset.url.replace(/limit=\d+/, `limit=${recommendationLimit}`);
    
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;

        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          // Accumulate the HTML content of each recommendation
          allRecommendationsHTML += recommendations.innerHTML;
        // console.log("allRecommendationsHTML",allRecommendationsHTML);
          // If this is the last section, set the HTML content
          if (index === itemCount - 1) {
            const productRecommendationsWrapper = cartDrawer.querySelector('.product-recommendations-wrapper');
            productRecommendationsWrapper.classList.add("swiper-wrapper");
            productRecommendationsWrapper.innerHTML = allRecommendationsHTML;
            upsellAdd(); // Ensure any additional logic runs after content is added
            setTimeout(function(){
              initSlideshow();
            },1000);
             
          }
        } else {
          console.error("No recommendations found in the fetched content.");
        }
      })
      .catch(e => {
        console.error("Error fetching recommendations:", e);
      });
  };

  // Iterate over all product sections and load recommendations
  productRecommendationsSections.forEach((section, index) => {
    setTimeout(() => loadRecommendations(section, index), 1000); // Adjust timing if needed
  });
}

function quickAddSwiper(){
  var quickAdds = document.querySelectorAll(".card-wrapper .quick-add__submit");
  // console.log("quickAdds",quickAdds);
if(quickAdds.length){
 quickAdds.forEach(function(quickAdd){
   quickAdd.addEventListener('click',function(){
     console.log("quickAdd clicked.....");
     // setTimeout(function(){
     //   initSlideshow();
     //    // pdpslider();
     //   let product_slider1 = document.querySelector('quick-add-modal .popup-media-gallery [data-pdp-slider-quickadd]');
     //     if(product_slider1){
     //       let sliderOptions = product_slider1.getAttribute('data-slider-options');
     //       let  slideroptionConfig = JSON.parse(sliderOptions);
     //       pop_slider = new Swiper("quick-add-modal .popup-media-gallery [data-main-pdp-swiper-quickadd]", slideroptionConfig);
     //    }
     // },1500);
   });
 })
}
}


class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
    document.body.classList.add("cartdrawer-open");
    document.body.classList.add('overflow-hidden');
    
    upsellRecommended();
     setTimeout(function(){
       quickAddSwiper();
     },2000);
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove("cartdrawer-open");
    
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
